// extracted by mini-css-extract-plugin
export default {"tableAvatar":"adminUserList_tableAvatar__KCHxb","tableAvatar__img":"adminUserList_tableAvatar__img__faEB1","rank":"adminUserList_rank__3xx3K","status":"adminUserList_status__9rb14"};